// extracted by mini-css-extract-plugin
module.exports = {"containerList":"SmallSpinner_containerList__3Rr59"};